import { AmplitudeEvent } from "@/telemetry/AmplitudeEvent";

export class CoachingContentViewedEvent extends AmplitudeEvent {
	constructor( coachingURL, fromLocation ) {
		super();
		this.name = "Coaching Content Viewed";
		this.eventProperties.from_location = fromLocation;
		this.eventProperties.view_url = coachingURL;
	}
}



// WEBPACK FOOTER //
// ./src/telemetry/CoachingContentViewedEvent.js